import { useEffect, useState } from "react";
import { Input, Boton, Spinner } from "asocomponents"
import JuicioServices from "../../../../../modules/Juicio/application/JuicioServices";
import ReactDOM from 'react-dom'

function ModalJuicios({ onClose, onSearchResult, cuitLetrado, referente }) {

  const [isUserMedico, setIsUserMedico] = useState()
  const [isUserTecnico, setIsUserTecnico] = useState()
  const [nroJuicio, setNroJuicio] = useState();
  const [nroSiniestro, setNroSiniestro] = useState();
  const [caratula, setCaratula] = useState();
  const [resultado, setResultado] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [limpiarFiltros, setLimpiarFiltros] = useState(false);

  const handleNumeroJuicio = (valor) => setNroJuicio(valor);
  const handleNroSiniestro = (valor) => setNroSiniestro(valor);
  const handleCaratula = (valor) => setCaratula(valor);

  const handleLimpiar = async () => {
    setNroJuicio("");
    setNroSiniestro("");
    setCaratula("");

    setLimpiarFiltros(!limpiarFiltros)
  }

  const handleBuscar = async () => {
    if (nroSiniestro || caratula || nroJuicio) {
      setIsLoading(true)
      const cuit = (isUserMedico === true || isUserTecnico === true) ? undefined : cuitLetrado;
      const juicioService = new JuicioServices(cuit, nroSiniestro, caratula, nroJuicio);
      const juicios = await juicioService.getJuicios()
      setResultado(juicios);
      setPaginaActual(1)
      setIsLoading(false)
    }
  };

  const handleSelectResult = (juicio) => {
    // Llama a la función de retorno con el ID del objeto seleccionado
    onSearchResult(juicio);
    // Cierra el modal
    onClose();
  };

  //PARA EL PAGINADO
  const [paginaActual, setPaginaActual] = useState(1);
  const [elementosPorPagina] = useState(3); // Cambia esto según cuántos elementos quieres mostrar por página
  let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

  const indiceUltimoElemento = paginaActual * elementosPorPagina;
  const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina;
  const elementosPaginados =
    resultado === null
      ? []
      : resultado.slice(indicePrimerElemento, indiceUltimoElemento);

  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina);
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    handleBuscar();
    setIsUserMedico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserMedico)
    setIsUserTecnico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserTecnico)
  }, [limpiarFiltros]);

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleBuscar();
    }
  };

  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-50 z-[9999]">
      <div className="bg-white p-8 rounded shadow-md w-[950px]">
        <h2 className="text-1xl font-semibold mb-4">Buscador de Proceso Judicial</h2>
        <div className="mb-2 text-right w-[95%]">
          <Boton onClick={handleLimpiar} texto="Nueva Busqueda" fondo="rojo" height="h-6" icono="filtro" />
        </div>
        <div className="grid grid-cols-4 gap-4 mb-4 items-end m-4">
          <div>
            <Input
              placeholder="Caratula"
              type="text"
              onChange={handleCaratula}
              disabled={false}
              onKeyDown={handleEnterPress}
              valor={caratula}
            />
          </div>

          <div>
            <Input
              placeholder="Nro Siniestro"
              type="text"
              onChange={handleNroSiniestro}
              disabled={false}
              onKeyDown={handleEnterPress}
              valor={nroSiniestro}
            />
          </div>

          <div>
            <Input
              placeholder="Nro Juicio"
              type="number"
              onChange={handleNumeroJuicio}
              disabled={false}
              onKeyDown={handleEnterPress}
              valor={nroJuicio}
            />
          </div>

          <div className="flex justify-left">
            <Boton
              onClick={handleBuscar}
              texto="Buscar"
              fondo="rojo"
              height="h-8"
            />
          </div>
        </div>
        {isLoading ?
          <Spinner color="red" size="30" /> :
          <div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg m-3">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-200">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-center" style={{ width: "10%" }}>
                      F. Notif.
                    </th>
                    <th scope="col" className="px-6 py-3 text-center" style={{ width: "30%" }}>
                      Caratula
                    </th>
                    <th scope="col" className="px-6 py-3 text-center" style={{ width: "8%" }}>
                      Expediente
                    </th>
                    <th scope="col" className="px-6 py-3 text-center" style={{ width: "10%" }}>
                      N.Siniestro
                    </th>
                    <th scope="col" className="px-6 py-3 text-center" style={{ width: "10%" }}>
                      T. Proceso
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {elementosPaginados &&
                    elementosPaginados.map((juicio) => (
                      <tr
                        className="bg-white border-b hover:bg-gray-50 text-xs text-center"
                        key={juicio.idJuicio}
                      >
                        <td className="px-6 py-4">{juicio.fechaNotificacion}</td>
                        {juicio.nroSiniestro ? (
                          <td
                            className='cursor-pointer text-blue-500'
                            onClick={() => handleSelectResult(juicio)}
                          >
                            {juicio.caratula}
                          </td>
                        ) : (
                          <td>{juicio.caratula}</td>
                        )}
                        <td className="px-6 py-4">{juicio.expediente}</td>
                        <td className="px-6 py-4">{juicio.nroSiniestro ? juicio.nroSiniestro : <Boton type="button" icono="info" width="w-2" alt={`Contactarse con su referente ${referente || ''}`} />}</td>
                        <td className="px-6 py-4">{juicio.tipoJuicio}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="col-span-2 flex justify-end items-center m-2">
              <span className="text-sm m-1">
                Página {paginaActual} de {totalPaginas}
              </span>
              <button
                className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                onClick={() => cambiarPagina(paginaActual - 1)}
                disabled={paginaActual === 1}
              >
                {"<"}
              </button>
              <button
                className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                onClick={() => cambiarPagina(paginaActual + 1)}
                disabled={
                  resultado ? indiceUltimoElemento >= resultado.length : true
                }
              >
                {">"}
              </button>
            </div>
          </div>
        }
        <div className="col-span-2 flex justify-end items-center">
          <Boton texto="Cerrar" height="h-8" onClick={onClose} fondo="gris" />
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default ModalJuicios;
